webpackJsonp([0],Array(25).concat([
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apps_carousel_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apps_scrollmagic_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apps_navigation_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apps_userinterface_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apps_video_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__apps_articlefeed_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__apps_faculty_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__apps_degreesAndPrograms_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__apps_programFinder_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__apps_news_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__apps_events_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__apps_search_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__apps_careers_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__apps_cookieAlert__ = __webpack_require__(41);



















__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {

    // init scripts being imported
    Object(__WEBPACK_IMPORTED_MODULE_6__apps_userinterface_js__["a" /* default */])();
    Object(__WEBPACK_IMPORTED_MODULE_3__apps_carousel_js__["a" /* default */])();
    Object(__WEBPACK_IMPORTED_MODULE_4__apps_scrollmagic_js__["a" /* default */])();
    Object(__WEBPACK_IMPORTED_MODULE_5__apps_navigation_js__["a" /* default */])();
    Object(__WEBPACK_IMPORTED_MODULE_7__apps_video_js__["a" /* default */])();
    Object(__WEBPACK_IMPORTED_MODULE_16__apps_cookieAlert__["a" /* default */])();

    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#articleFeed").length > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_8__apps_articlefeed_js__["a" /* default */])();
    }
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#facultyFinder").length > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_9__apps_faculty_js__["a" /* default */])();
    }
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#degreesAndProgramFinder").length > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_10__apps_degreesAndPrograms_js__["a" /* default */])();
    }
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#programFinder").length > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_11__apps_programFinder_js__["a" /* default */])();
    }
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#newsListing").length > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_12__apps_news_js__["a" /* default */])();
    }
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#eventListing").length > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_13__apps_events_js__["a" /* default */])();
    }
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#degreesAndProgramFinder").length > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_15__apps_careers_js__["a" /* default */])();
    }

    Object(__WEBPACK_IMPORTED_MODULE_14__apps_search_js__["a" /* default */])();

    // console.log(window);
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//dependencies


/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initCarousel() {

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.t1-slider').slick({
            autoplay: false,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow_slider_left"></i></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow_slider"></i></button>',
            fade: false,
            dots: false,
            focusOnSelect: true,
            mobileFirst: false,
            rows: 0
            // responsive: [{
            //     breakpoint: 999999,
            //     settings: "unslick"
            // }, {
            //     breakpoint: 767,
            //     settings: {
            //         dots: true,
            //         swipe: true,
            //         slide: '.slide'
            //     }
            // }]
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.three-col-slider').not('.slick-initialized').slick({
            autoplay: false,
            autoplaySpeed: 5000,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow_slider_left"></i></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow_slider"></i></button>',
            fade: false,
            dots: false,
            focusOnSelect: true,
            mobileFirst: false,
            rows: 0,
            responsive: [{
                breakpoint: 767,
                settings: {
                    swipe: true,
                    slidesToShow: 1
                }
            }]
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.full-width-slider').not('.slick-initialized').slick({
            autoplay: false,
            autoplaySpeed: 5000,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow_slider_left"></i></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow_slider"></i></button>',
            fade: false,
            dots: false,
            focusOnSelect: true,
            mobileFirst: false,
            centerMode: true,
            rows: 0,
            responsive: [{
                breakpoint: 1850,
                settings: {
                    slidesToShow: 1
                }
            }, {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '30%'
                }
            }, {
                breakpoint: 1350,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '20%'
                }
            }, {
                breakpoint: 955,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '10%'
                }
            }, {
                breakpoint: 767,
                settings: "unslick"
            }]
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.disable-slider').not('.slick-initialized').slick({
            settings: "unslick"
        });

        console.log('init carousel');
    }

    // function reinitCarousel() {
    //     var $navTab = $('.in-page-tabs ul li a');
    //     console.log('tab clicked');
    //
    //     $navTab.on('click', function() {
    //         $('.three-col-slider').not('.slick-initialized').slick('resize');
    //     })
    // }

    // reinitCarousel();
    initCarousel();
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scrollmagic__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scrollmagic__);


/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initScrollMagic() {
        var controller = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Controller();
        // var scene = new ScrollMagic.Scene();
        // var enabled = controller.enabled();
        // var $mobileMenu = $('.hamburger');
        // var $html = $('html');

        function disableScrollMagic() {
            controller.enabled(false);
        }

        // $mobileMenu.on('click', function(){
        //     $html.toggleClass('menu-is-open');
        //     controller.enabled(false);
        //
        //     if ($html.hasClass('menu-is-open')) {
        //         $mobileMenu.on('click', function() {
        //             controller.enabled(true);
        //         })
        //     }
        // })

        function desktopScrollMagic() {
            console.log('this works');
            const pinHero = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '#main-hero',
                triggerHook: 'onLeave',
                duration: '200%'
                //offset: -140
            }).setClassToggle('#main-hero', 'stick').setPin('#main-hero').addTo(controller);

            const heroSlider1 = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.col-slider-l',
                triggerHook: 'onLeave',
                duration: '100%'
            }).setPin('.col-slider-l').addTo(controller);

            const heroSlider2 = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave',
                duration: '100%'
            }).addTo(controller);

            const releaseWrapper = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave'
            }).setClassToggle('.main-wrapper', 'release').addTo(controller);

            const dropBorder = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave'
            }).setClassToggle('header', 'slide-border').addTo(controller);
        }

        function microclimate() {
            const pinHero = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '#main-hero',
                triggerHook: 'onLeave',
                duration: '200%' //,
                //offset: -221
            }).setClassToggle('#main-hero', 'stick').setPin('#main-hero').addTo(controller);

            const heroSlider1 = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.col-slider-l',
                triggerHook: 'onLeave',
                duration: '100%' //,
                //offset: -221
            }).setPin('.col-slider-l').addTo(controller);

            const heroSlider2 = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave',
                duration: '100%' //,
                //offset: -221
            }).addTo(controller);

            const releaseWrapper = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave' //,
                //offset: -221
            }).setClassToggle('.main-wrapper', 'release').addTo(controller);

            const dropBorder = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave'
            }).setClassToggle('header', 'slide-border').addTo(controller);

            const mcStickyNav = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave'
            }).setClassToggle('.mc-dropdown-nav', 'slide-mc-nav').addTo(controller);

            const mcStickyLogo = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave'
            }).setClassToggle('.logo-title-container', 'slide-logo-title').addTo(controller);

            const mcNavContainer = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.col-slider-r',
                triggerHook: 'onLeave'
            }).setClassToggle('.nav-container', 'slide-nav-container').addTo(controller);
        }

        function stickyNav() {
            console.log('this works');
            const dropBorder2 = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.tier-header',
                triggerHook: 'onLeave'
            }).setClassToggle('header', 'slide-border').addTo(controller);
        }

        function microclimateNav() {
            const mcStickyNav2 = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.tier-header',
                triggerHook: 'onLeave'
            }).setClassToggle('.mc-dropdown-nav', 'slide-mc-nav').addTo(controller);

            const mcStickyLogo2 = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.tier-header',
                triggerHook: 'onLeave'
            }).setClassToggle('.logo-title-container', 'slide-logo-title').addTo(controller);

            const mcNavContainer2 = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                triggerElement: '.tier-header',
                triggerHook: 'onLeave'
            }).setClassToggle('.nav-container', 'slide-nav-container').addTo(controller);
        }

        function checkForSlides() {
            if ($('body').find('.col-slider-l').length) {
                desktopScrollMagic();
            } else if ($('header').find('.microclimate-nav').length) {
                microclimateNav();
            } else if ($('header').find('.tier-header').length) {
                stickyNav();
            } else {
                // $('#main-hero').addClass('dropHero');
                $('.placeholder-class').addClass('dropHero');
            }
        }

        function checkViewPort() {
            if (window.matchMedia("(max-width: 767px)").matches) {
                disableScrollMagic();
            }
        }

        checkViewPort();
        checkForSlides();
        // microclimate();
    }

    function initNavigationScroll() {
        var controller = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Controller();
        var $header = $("#header");

        if ($(window).width() < 992 && controller.enabled()) {
            controller.enabled(false);
        } else {
            new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
                duration: 0,
                triggerHook: 0,
                offset: 250,
                reverse: true
            }).on("enter", function () {
                var headerHeight = $header.height();
                $header.before("<div class='header-container-spacer' style='height:" + headerHeight + "px'></div>");
                $header.addClass("fixed-top slide-down");
            }).on("leave", function () {
                $header.removeClass("fixed-top slide-down");
                $(".header-container-spacer").remove();
            }).addTo(controller);
        }

        $(window).resize(function () {
            if ($(window).width() < 992 && controller.enabled()) {
                controller.enabled(false);
            } else {
                controller.enabled(true);
            }
            controller.update(true);
        });
    }

    initNavigationScroll();
    initScrollMagic();
});;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initT1Navigation() {
        console.log('init navigation');

        var $trigger = $('.t1-nav .has-menu'); // only items with class .has-menu will trigger
        var $menu = $('.t1-menu-container .collapsed-menu');
        var $close = $('.t1-menu-container .close-menu');
        var $body = $('body');
        var $menuContainer = $('.t1-menu-container');

        // close menu function
        function closeNavMenu(e) {
            $menu.slideUp(function () {
                $menu.removeClass('menu-open');
                $('.t1-nav .has-menu.active a').focus();
                $trigger.removeClass('active');
                $trigger.find('> a').attr('aria-expanded', 'false'); // accessibility
            });
            $body.removeClass('menu-is-open');
            $menuContainer.removeClass('menu-spacing');

            e.preventDefault();
        }

        // Focus Trap
        $menuContainer.on('keydown', function (event) {
            if (event.which == 9) {
                var tabbableElements = $menuContainer.find('a[href]:visible, area[href], input:not([disabled]):visible, select:not([disabled]):visible, textarea:not([disabled]):visible, button:not([disabled]):visible, iframe:visible, [tabindex]:visible, [contentEditable=true]:visible');
                var thisElementIndex = -1;
                if (event.shiftKey) {
                    thisElementIndex = tabbableElements.index(document.activeElement);
                    //if this element is the first one in the tabbable elements, then we need to go back to the last element.
                    if (thisElementIndex == 0) {
                        event.preventDefault();
                        $(tabbableElements.get(tabbableElements.length - 1)).focus();
                    }
                } else {
                    //if this element is the last one in the tabbable elements, then we need to go back to the first element.
                    thisElementIndex = tabbableElements.index(document.activeElement);
                    if (thisElementIndex == tabbableElements.length - 1) {
                        event.preventDefault();
                        $(tabbableElements.get(0)).focus();
                    }
                }
            }
        });

        if ($trigger.length > 0) {
            $trigger.on('click', function (e) {
                var $this = $(this);
                var target = $this.find('> a').data('target');
                // check if t1 menu is currently animating - prevent clicks
                if ($trigger.is('.animating')) {
                    e.stopPropagation();
                }
                // check if t1 menu is already open - if it is close menu
                else if ($this.hasClass('active')) {
                        $this.removeClass('active');
                        $this.find('> a').attr('aria-expanded', 'false'); // accessibility
                        $(target).slideUp(function () {
                            $(target).removeClass('menu-open');
                            $body.removeClass('menu-is-open');
                            $menuContainer.removeClass('menu-spacing');
                        });
                    }
                    // check if t1 menu is open while another nav item is clicked - close current menu and open the new one
                    else if ($menu.is('.menu-open:visible')) {
                            // console.log('boom')
                            var $menuOpen = $menu.closest('.menu-open');
                            $trigger.removeClass('active');
                            $trigger.find('> a').attr('aria-expanded', 'false'); // accessibility
                            $this.addClass('animating');
                            $menuOpen.slideUp({
                                complete: function () {
                                    $menu.removeClass('menu-open');
                                    $(target).slideDown(function () {
                                        $(target).addClass('menu-open').focus();
                                        $trigger.removeClass('animating');
                                    });
                                    $this.addClass('active');
                                    $this.find('> a').attr('aria-expanded', 'true'); // accessibility
                                }
                            });
                        }
                        // open targeted menu
                        else {
                                $this.addClass('animating');
                                $(target).slideDown(function () {
                                    $(target).addClass('menu-open').focus();
                                    $trigger.removeClass('animating');
                                    $('.t1-menu-container .nav-content a').focus();
                                });
                                $body.addClass('menu-is-open');
                                $menuContainer.addClass('menu-spacing');
                                $this.addClass('active');
                                $this.find('> a').attr('aria-expanded', 'true'); // accessibility

                                // Add ESC key functionality to close visible menu
                                $(document).keyup(function (e) {
                                    if (e.keyCode === 27) {
                                        closeNavMenu();
                                    }
                                    e.preventDefault();
                                });
                            }
                e.preventDefault();
            });

            // close menu
            $close.on('click', closeNavMenu);
        }
    }

    function initHamburgerNavigation() {

        var $menuTrigger = $('.t1-nav .mobile-menu'); // mobile hamburg trigger
        var $linkTrigger = $('.mobile-t1-nav .has-menu'); // only items with class .has-menu will trigger
        var $menuContainer = $('#mobileMenu');
        var $menu = $('.nav-content .mobile-t1-nav .collapsed-menu');
        var $close = $('.t1-nav .mobile-menu > a');

        function closeMobileNavMenu(e) {
            $menuContainer.slideUp(function () {
                $menuContainer.removeClass('menu-open');
                $menuTrigger.removeClass('animating');
                $menuTrigger.removeClass('active');
                $menuTrigger.find('> a').attr('aria-expanded', 'false');
            });
            e.preventDefault();
        }

        if ($menuTrigger.length > 0) {
            $menuTrigger.on('click', function (e) {
                var $this = $(this);
                var target = $this.data('target');
                if ($menuTrigger.is('.animating')) {
                    event.stopPropagation();
                } else if ($this.hasClass('active')) {
                    $this.removeClass('active');
                    $this.attr('aria-expanded', 'false');
                    $(target).slideUp(function () {
                        $(target).removeClass('menu-open');
                    });
                } else if ($menuContainer.is('.menu-open:visible')) {
                    var $menuOpen = $menuContainer.closest('.menu-open');
                    $menuTrigger.removeClass('active');
                    $menuTrigger.find('> a').attr('aria-expanded', 'false');
                    $this.addClass('animating');

                    $menuOpen.slideUp({
                        complete: function () {
                            $menuContainer.removeClass('menu-open');
                            $(target).slideDown(function () {
                                $(target).addClass('menu-open').focus();
                                $menuTrigger.removeClass('animating');
                            });
                        }
                    });
                } else {
                    $this.addClass('animating');
                    $(target).slideDown(function () {
                        $(target).addClass('menu-open').focus();
                        $menuTrigger.removeClass('animating');
                    });
                    $this.addClass('active');
                    $this.attr('aria-expanded', 'true');
                }
                e.preventDefault();
            });

            $linkTrigger.find('> a').on('click', function (e) {
                var $this = $(this).parent();
                var target = $this.find('> a').data('target');
                if ($linkTrigger.is('.animating')) {
                    event.stopPropagation();
                } else if ($this.hasClass('active')) {
                    $this.removeClass('active');
                    $this.find('> a').attr('aria-expanded', 'false');
                    $(target).slideUp(function () {
                        $(target).removeClass('sub-menu-open');
                    });
                } else if ($menu.is('.sub-menu-open:visible')) {
                    var $menuOpen = $menu.closest('.sub-menu-open');
                    $linkTrigger.removeClass('active');
                    $linkTrigger.find('> a').attr('aria-expanded', 'false');
                    $this.addClass('animating');
                    $menuOpen.slideUp({
                        complete: function () {
                            $menu.removeClass('sub-menu-open');
                            $(target).slideDown(function () {
                                $linkTrigger.removeClass('animating');
                                $(target).addClass('sub-menu-open').focus();
                            });
                            $this.addClass('active');
                            $this.find('> a').attr('aria-expanded', 'true');
                        }
                    });
                } else {
                    $this.addClass('animating');
                    $(target).slideDown(function () {
                        $(target).addClass('sub-menu-open').focus();
                        $linkTrigger.removeClass('animating');
                    });
                    $this.addClass('active');
                    $this.find('> a').attr('aria-expanded', 'true');
                }
                e.preventDefault();
            });
            $close.on('click', closeMobileNavMenu);
        }
    }

    function initHamburgerNavigationMicro() {

        var $menuTrigger = $('.mc-mobile-nav .mc-mobile-trigger'); // mobile hamburg trigger
        var $linkTrigger = $('.mobile-t1-nav .has-menu'); // only items with class .has-menu will trigger
        var $menuContainer = $('#mobileMenu');
        var $menu = $('.nav-content .mobile-t1-nav .collapsed-menu');
        var $close = $('.mc-mobile-nav .mc-mobile-trigger > a');

        function closeMobileNavMenu(e) {
            $menuContainer.slideUp(function () {
                $menuContainer.removeClass('menu-open');
                $menuTrigger.removeClass('animating');
                $menuTrigger.removeClass('active');
                $menuTrigger.find('> a').attr('aria-expanded', 'false');
            });
            e.preventDefault();
        }

        if ($menuTrigger.length > 0) {
            $menuTrigger.on('click', function (e) {
                var $this = $(this);
                var target = $this.data('target');
                if ($menuTrigger.is('.animating')) {
                    event.stopPropagation();
                } else if ($this.hasClass('active')) {
                    $this.removeClass('active');
                    $this.attr('aria-expanded', 'false');
                    $(target).slideUp(function () {
                        $(target).removeClass('menu-open');
                    });
                } else if ($menuContainer.is('.menu-open:visible')) {
                    var $menuOpen = $menuContainer.closest('.menu-open');
                    $menuTrigger.removeClass('active');
                    $menuTrigger.find('> a').attr('aria-expanded', 'false');
                    $this.addClass('animating');

                    $menuOpen.slideUp({
                        complete: function () {
                            $menuContainer.removeClass('menu-open');
                            $(target).slideDown(function () {
                                $(target).addClass('menu-open').focus();
                                $menuTrigger.removeClass('animating');
                            });
                        }
                    });
                } else {
                    $this.addClass('animating');
                    $(target).slideDown(function () {
                        $(target).addClass('menu-open').focus();
                        $menuTrigger.removeClass('animating');
                    });
                    $this.addClass('active');
                    $this.attr('aria-expanded', 'true');
                }
                e.preventDefault();
            });

            $linkTrigger.find('> a').on('click', function (e) {
                var $this = $(this).parent();
                var target = $this.find('> a').data('target');
                if ($linkTrigger.is('.animating')) {
                    event.stopPropagation();
                } else if ($this.hasClass('active')) {
                    $this.removeClass('active');
                    $this.find('> a').attr('aria-expanded', 'false');
                    $(target).slideUp(function () {
                        $(target).removeClass('sub-menu-open');
                    });
                } else if ($menu.is('.sub-menu-open:visible')) {
                    var $menuOpen = $menu.closest('.sub-menu-open');
                    $linkTrigger.removeClass('active');
                    $linkTrigger.find('> a').attr('aria-expanded', 'false');
                    $this.addClass('animating');
                    $menuOpen.slideUp({
                        complete: function () {
                            $menu.removeClass('sub-menu-open');
                            $(target).slideDown(function () {
                                $linkTrigger.removeClass('animating');
                                $(target).addClass('sub-menu-open').focus();
                            });
                            $this.addClass('active');
                            $this.find('> a').attr('aria-expanded', 'true');
                        }
                    });
                } else {
                    $this.addClass('animating');
                    $(target).slideDown(function () {
                        $(target).addClass('sub-menu-open').focus();
                        $linkTrigger.removeClass('animating');
                    });
                    $this.addClass('active');
                    $this.find('> a').attr('aria-expanded', 'true');
                }
                e.preventDefault();
            });
            $close.on('click', closeMobileNavMenu);
        }
    }

    initT1Navigation();
    initHamburgerNavigation();
    initHamburgerNavigationMicro();
});;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_textillate__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_textillate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_textillate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lettering_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lettering_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lettering_js__);



/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initUserInterface() {
        // bind a click event to the 'skip-nav' link and give focus
        var $this = $(this);

        $(".skip-nav").click(function () {
            var skipTo = "#" + this.href.split('#')[1];
            $(skipTo).attr('tabindex', -1).on('blur focusout', function () {
                $this.removeAttr('tabindex');
            }).focus();
        });

        // Script to scroll to top after accordion is open to offset the large accordions
        $('.collapse').on('shown.bs.collapse', function () {
            var $card = $(this).closest('.card');
            $('html,body').animate({
                scrollTop: $card.offset().top - 140
            }, 500);
        });

        // $('.career-picker-row a.btn.white').on('click', function() {
        //     $('html,body').animate({
        //         scrollTop: $(this).offset().top
        //     }, 500);
        // });

        //setupSmoothScroll
        var anchorLink = $('.anchor-link');
        if (anchorLink.length > 0) {
            anchorLink.on('click', function (event) {
                event.preventDefault();
                var offset = $($(this).attr('href')).offset().top - 100;
                var $offsetTarget = $($(this).attr('href'));
                $('html, body').animate({ scrollTop: offset }, 500, function () {
                    $offsetTarget.attr('tabindex', -1).focus();
                });
            });
        }

        $(window).scroll(function () {
            var scroll = $(window).scrollTop();

            if (scroll >= 800) {
                $(".back-to-top").addClass("show");
            } else {
                $(".back-to-top").removeClass("show");
            }
        });

        // Add to Any
        function addToAny() {
            $('<script>var a2a_config = a2a_config || {}; a2a_config.templates = {email: { subject: "${title}", body: "Check out this website: ${link}"}};</' + 'script>').appendTo(document.body);

            var addtoanyScript = document.createElement('script');
            addtoanyScript.setAttribute('src', '//static.addtoany.com/menu/page.js');
            document.body.appendChild(addtoanyScript);
        }

        // Bootstrap Select
        function bootstrapSelect() {
            $('select').selectpicker();

            var $showMore = $('.show-more');
            var $newsSection = $('.news-section');
            var $newsSectionRow = $('.news-section .news-block > .row').not(":eq(0)");

            if ($newsSection.length > 0) {
                $newsSectionRow.attr('aria-expanded', 'false');
                $newsSectionRow.attr('tabindex', '-1');
                $newsSectionRow.addClass('hidden');
            }

            $showMore.on('click', function () {
                $newsSection.toggleClass('open-news');

                $newsSectionRow.attr('aria-expanded', $newsSectionRow.attr('aria-expanded') == 'false' ? 'true' : 'false');
                $newsSectionRow.attr('tabindex', $newsSectionRow.attr('tabindex') == '-1' ? '0' : '-1');
                $newsSectionRow.toggleClass('hidden');

                $('.more').toggleClass('hide');
                $('.less').toggleClass('hide');
            });

            var $loadMore = $('.load-more');
            var $programDirectory = $('.program-container');
            $loadMore.on('click', function () {
                $programDirectory.toggleClass('show-programs');
            });
        }

        $('.close-alert').on('click', function () {
            $('.alert').toggleClass('closed');
        });

        var $slideUpCards = $('.card-content');
        var $slideUpCardTrigger = $('.tile-link');

        $slideUpCardTrigger.on('click', function () {
            $this.closest($slideUpCards).toggleClass('slide-up');
        });

        function closePreviousCareer() {
            var $myGroup = $('.career-picker-row');
            $myGroup.on('show.bs.collapse', '.collapse', function () {
                $myGroup.find('.collapse.show').collapse('hide');
            });
        }

        // Video Transcript button
        $('.play-with-transcript').on('click', function (e) {
            // Play video automatcially
            $('#housingVideo')[0].src += '?autoplay=1';
        });

        // Deep linking
        function deepLinkDegreeTabs() {

            var url = document.location.toString();

            if (url.match('#')) {
                $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
            }

            //Change hash for page-reload
            $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').on('shown', function (e) {
                window.location.hash = e.target.hash;
            });
        }

        // prevent scrolling
        function preventScroll() {
            function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            }

            function preventDefaultForScrollKeys(e) {
                if (keys[e.keyCode]) {
                    preventDefault(e);
                    return false;
                }
            }

            function disableScroll() {
                if (window.addEventListener) // older FF
                    window.addEventListener('DOMMouseScroll', preventDefault, false);
                window.onwheel = preventDefault; // modern standard
                window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
                window.ontouchmove = preventDefault; // mobile
                document.onkeydown = preventDefaultForScrollKeys;
            }

            function enableScroll() {
                if (window.removeEventListener) window.removeEventListener('DOMMouseScroll', preventDefault, false);
                window.onmousewheel = document.onmousewheel = null;
                window.onwheel = null;
                window.ontouchmove = null;
                document.onkeydown = null;
            }
        }

        //refresh page on browser resize while storing window width
        function pageReload() {

            if ($('body').find('.col-slider-l').length) {
                onHomepage();
            }

            function onHomepage() {
                var windowWidth = $(window).width();

                $(window).resize(function () {
                    // Check if the window width has actually changed and it's not just iOS triggering a resize event on scroll
                    if ($(window).width() != windowWidth) {

                        // Update the window width for next time
                        windowWidth = $(window).width();

                        $(window).bind('resize', function () {
                            if (window.RT) clearTimeout(window.RT);
                            window.RT = setTimeout(function () {
                                this.location.reload(false); /* false to get page from cache */
                            }, 100);
                        });
                    }
                });
            }
        }

        function initSwapText() {
            $('.filter-trigger').click(function () {
                var $this = $(this);
                $this.toggleClass('collapsed');
                if ($this.hasClass('collapsed')) {
                    $this.text('Show More Filters');
                } else {
                    $this.text('Show Fewer Filters');
                }
            });
        }

        addToAny();
        bootstrapSelect();
        deepLinkDegreeTabs();
        preventScroll();
        pageReload();
        initSwapText();
    }

    initUserInterface();

    $(document).ready(function () {
        if ($('.col-slider-r').length) {
            $('body').addClass('homepage');
        }

        if ($('.bootstrap-select').length > 0) {
            $(this).find('ul.dropdown-menu li').each(function () {
                $(this).find('a').attr('href', "javascript:void(0)");
            });
        }
    });
});;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*
 * textillate.js
 * http://jschr.github.com/textillate
 * MIT licensed
 *
 * Copyright (C) 2012-2013 Jordan Schroter
 */

(function ($) {
  "use strict";

  function isInEffect (effect) {
    return /In/.test(effect) || $.inArray(effect, $.fn.textillate.defaults.inEffects) >= 0;
  };

  function isOutEffect (effect) {
    return /Out/.test(effect) || $.inArray(effect, $.fn.textillate.defaults.outEffects) >= 0;
  };


  function stringToBoolean(str) {
    if (str !== "true" && str !== "false") return str;
    return (str === "true");
  };

  // custom get data api method
  function getData (node) {
    var attrs = node.attributes || []
      , data = {};

    if (!attrs.length) return data;

    $.each(attrs, function (i, attr) {
      var nodeName = attr.nodeName.replace(/delayscale/, 'delayScale');
      if (/^data-in-*/.test(nodeName)) {
        data.in = data.in || {};
        data.in[nodeName.replace(/data-in-/, '')] = stringToBoolean(attr.nodeValue);
      } else if (/^data-out-*/.test(nodeName)) {
        data.out = data.out || {};
        data.out[nodeName.replace(/data-out-/, '')] =stringToBoolean(attr.nodeValue);
      } else if (/^data-*/.test(nodeName)) {
        data[nodeName.replace(/data-/, '')] = stringToBoolean(attr.nodeValue);
      }
    })

    return data;
  }

  function shuffle (o) {
      for (var j, x, i = o.length; i; j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
      return o;
  }

  function animate ($t, effect, cb) {
    $t.addClass('animated ' + effect)
      .css('visibility', 'visible')
      .show();

    $t.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
        $t.removeClass('animated ' + effect);
        cb && cb();
    });
  }

  function animateTokens ($tokens, options, cb) {
    var that = this
      , count = $tokens.length;

    if (!count) {
      cb && cb();
      return;
    }

    if (options.shuffle) $tokens = shuffle($tokens);
    if (options.reverse) $tokens = $tokens.toArray().reverse();

    $.each($tokens, function (i, t) {
      var $token = $(t);

      function complete () {
        if (isInEffect(options.effect)) {
          $token.css('visibility', 'visible');
        } else if (isOutEffect(options.effect)) {
          $token.css('visibility', 'hidden');
        }
        count -= 1;
        if (!count && cb) cb();
      }

      var delay = options.sync ? options.delay : options.delay * i * options.delayScale;

      $token.text() ?
        setTimeout(function () { animate($token, options.effect, complete) }, delay) :
        complete();
    });
  };

  var Textillate = function (element, options) {
    var base = this
      , $element = $(element);

    base.init = function () {
      base.$texts = $element.find(options.selector);

      if (!base.$texts.length) {
        base.$texts = $('<ul class="texts"><li>' + $element.html() + '</li></ul>');
        $element.html(base.$texts);
      }

      base.$texts.hide();

      base.$current = $('<span>')
        .html(base.$texts.find(':first-child').html())
        .prependTo($element);

      if (isInEffect(options.in.effect)) {
        base.$current.css('visibility', 'hidden');
      } else if (isOutEffect(options.out.effect)) {
        base.$current.css('visibility', 'visible');
      }

      base.setOptions(options);

      base.timeoutRun = null;

      setTimeout(function () {
        base.options.autoStart && base.start();
      }, base.options.initialDelay)
    };

    base.setOptions = function (options) {
      base.options = options;
    };

    base.triggerEvent = function (name) {
      var e = $.Event(name + '.tlt');
      $element.trigger(e, base);
      return e;
    };

    base.in = function (index, cb) {
      index = index || 0;

      var $elem = base.$texts.find(':nth-child(' + ((index||0) + 1) + ')')
        , options = $.extend(true, {}, base.options, $elem.length ? getData($elem[0]) : {})
        , $tokens;

      $elem.addClass('current');

      base.triggerEvent('inAnimationBegin');
      $element.attr('data-active', $elem.data('id'));

      base.$current
        .html($elem.html())
        .lettering('words');

      // split words to individual characters if token type is set to 'char'
      if (base.options.type == "char") {
        base.$current.find('[class^="word"]')
            .css({
              'display': 'inline-block',
              // fix for poor ios performance
              '-webkit-transform': 'translate3d(0,0,0)',
              '-moz-transform': 'translate3d(0,0,0)',
              '-o-transform': 'translate3d(0,0,0)',
              'transform': 'translate3d(0,0,0)'
            })
            .each(function () { $(this).lettering() });
      }

      $tokens = base.$current
        .find('[class^="' + base.options.type + '"]')
        .css('display', 'inline-block');

      if (isInEffect(options.in.effect)) {
        $tokens.css('visibility', 'hidden');
      } else if (isOutEffect(options.in.effect)) {
        $tokens.css('visibility', 'visible');
      }

      base.currentIndex = index;

      animateTokens($tokens, options.in, function () {
        base.triggerEvent('inAnimationEnd');
        if (options.in.callback) options.in.callback();
        if (cb) cb(base);
      });
    };

    base.out = function (cb) {
      var $elem = base.$texts.find(':nth-child(' + ((base.currentIndex||0) + 1) + ')')
        , $tokens = base.$current.find('[class^="' + base.options.type + '"]')
        , options = $.extend(true, {}, base.options, $elem.length ? getData($elem[0]) : {})

      base.triggerEvent('outAnimationBegin');

      animateTokens($tokens, options.out, function () {
        $elem.removeClass('current');
        base.triggerEvent('outAnimationEnd');
        $element.removeAttr('data-active');
        if (options.out.callback) options.out.callback();
        if (cb) cb(base);
      });
    };

    base.start = function (index) {
      setTimeout(function () {
        base.triggerEvent('start');

        (function run (index) {
          base.in(index, function () {
            var length = base.$texts.children().length;

            index += 1;

            if (!base.options.loop && index >= length) {
              if (base.options.callback) base.options.callback();
              base.triggerEvent('end');
            } else {
              index = index % length;

              base.timeoutRun = setTimeout(function () {
                base.out(function () {
                  run(index)
                });
              }, base.options.minDisplayTime);
            }
          });
        }(index || 0));
      }, base.options.initialDelay);
    };

    base.stop = function () {
      if (base.timeoutRun) {
        clearInterval(base.timeoutRun);
        base.timeoutRun = null;
      }
    };

    base.init();
  }

  $.fn.textillate = function (settings, args) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('textillate')
        , options = $.extend(true, {}, $.fn.textillate.defaults, getData(this), typeof settings == 'object' && settings);

      if (!data) {
        $this.data('textillate', (data = new Textillate(this, options)));
      } else if (typeof settings == 'string') {
        data[settings].apply(data, [].concat(args));
      } else {
        data.setOptions.call(data, options);
      }
    })
  };

  $.fn.textillate.defaults = {
    selector: '.texts',
    loop: false,
    minDisplayTime: 2000,
    initialDelay: 0,
    in: {
      effect: 'fadeInLeftBig',
      delayScale: 1.5,
      delay: 50,
      sync: false,
      reverse: false,
      shuffle: false,
      callback: function () {}
    },
    out: {
      effect: 'hinge',
      delayScale: 1.5,
      delay: 50,
      sync: false,
      reverse: false,
      shuffle: false,
      callback: function () {}
    },
    autoStart: true,
    inEffects: [],
    outEffects: [ 'hinge' ],
    callback: function () {},
    type: 'char'
  };

}(jQuery));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global jQuery, define */
/*!
 * Lettering.JS 0.7.0
 *
 * Copyright 2010, Dave Rupert http://daverupert.com
 * Released under the WTFPL license
 * http://sam.zoy.org/wtfpl/
 *
 * Thanks to Paul Irish - http://paulirish.com - for the feedback.
 *
 * Date: Mon Sep 20 17:14:00 2010 -0600
 */

(function (factory) {
  'use strict'
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports !== 'undefined') {
    module.exports = factory(require('jquery'))
  } else {
    factory(jQuery)
  }
}(function ($) {
  function injector (t, splitter, klass, after) {
    var text = t.text()
    var a = text.split(splitter)
    var inject = ''
    if (a.length) {
      $(a).each(function (i, item) {
        inject += '<span class="' + klass + (i + 1) + '" aria-hidden="true">' + item + '</span>' + after
      })
      t.attr('aria-label', text)
        .empty()
        .append(inject)
    }
  }

  var methods = {
    init: function () {
      return this.each(function () {
        injector($(this), '', 'char', '')
      })
    },

    words: function () {
      return this.each(function () {
        injector($(this), ' ', 'word', ' ')
      })
    },

    lines: function () {
      return this.each(function () {
        var r = 'eefec303079ad17405c889e092e105b0'
        // Because it's hard to split a <br/> tag consistently across browsers,
        // (*ahem* IE *ahem*), we replace all <br/> instances with an md5 hash
        // (of the word "split").  If you're trying to use this plugin on that
        // md5 hash string, it will fail because you're being ridiculous.
        injector($(this).children('br').replaceWith(r).end(), r, 'line', '')
      })
    }
  }

  $.fn.lettering = function (method) {
    // Method calling logic
    if (method && methods[method]) {
      return methods[ method ].apply(this, [].slice.call(arguments, 1))
    } else if (method === 'letters' || !method) {
      return methods.init.apply(this, [].slice.call(arguments, 0)) // always pass an array
    }
    $.error('Method ' + method + ' does not exist on jQuery.lettering')
    return this
  }
}))


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
// dependencies


/* harmony default export */ __webpack_exports__["a"] = (function () {
    // initVideoJS
    function initVideoJS() {
        var $videoJS = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('video-js');
        if ($videoJS.length > 0) {
            // Initiate VideoJS
            videojs();
        }
    }

    function initVideoVersion1() {

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.video-module a.play-video').on('click', function (e) {

            var videoModuleContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parents('.video-module');

            videoModuleContainer.find('figure').fadeOut('slow');
            hideVideoContent();
            videoModuleContainer.find('.close').fadeIn('slow');
            videoModuleContainer.find('.embed-responsive').css({ 'z-index': '9' });
            e.preventDefault();

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#curryVideo')[0].src += '?autoplay=1';

            function hideVideoContent() {
                if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).width() > 768) {
                    videoModuleContainer.find('.container').fadeOut('slow');
                }
            }
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.video-module a.close').on('click', function (e) {

            var videoModuleContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parents('.video-module');
            videoModuleContainer.find('figure').fadeIn();
            videoModuleContainer.find('.container').fadeIn();
            videoModuleContainer.find('.close').fadeOut('slow');
            videoModuleContainer.find('.embed-responsive').css({ 'z-index': '-1' });
            e.preventDefault();

            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#curryVideo').length > 0) {
                var video = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#curryVideo").attr("src");
                var videoURL = video.split('?')[0];
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#curryVideo").attr("src", "");
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#curryVideo").attr("src", videoURL);
            } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#curryVideo2').length > 0) {
                videoModuleContainer.find('.play-button').fadeIn('slow');
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.full-width-video').toggleClass('hide-bg');
                videoModuleContainer.find('.video-caption').fadeIn();
                var video2 = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#curryVideo2").attr("src");
                var videoURL2 = video2.split('?')[0];
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#curryVideo2").attr("src", "");
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#curryVideo2").attr("src", videoURL2);
            }
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.video-module a.play-button').on('click', function (e) {

            var videoModuleContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parents('.video-module');

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.full-width-video').toggleClass('hide-bg');
            videoModuleContainer.find('figure').fadeOut('slow');
            videoModuleContainer.find('.play-button').fadeOut('slow');
            videoModuleContainer.find('.video-caption').fadeOut('slow');
            videoModuleContainer.find('.close').fadeIn('slow');
            videoModuleContainer.find('.embed-responsive').css({ 'z-index': '9' });
            e.preventDefault();

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#curryVideo2')[0].src += '?autoplay=1';
        });
    }

    initVideoJS();
    initVideoVersion1();
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//dependencies


/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initScript() {

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").on("click", "a[id^=factFeedBtn]", function (e) {
            e.preventDefault();
            // Get the parent of this button.
            var parentContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest("div[id^=factFeed]");
            var pageId = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("page");
            getCuriouslyCurryFact(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(parentContainer), pageId);
        });
    }

    function getCuriouslyCurryFact(element, pageId) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            url: window.curry.factFeed,
            type: "GET",
            data: {
                FactId: pageId
            },
            cache: false,
            success: function (response) {
                element.html(response);
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    initScript();
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//dependencies


/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initScript() {

        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#facultyFinder").length > 0) {
            // Faculty Data Initial load
            getFacultyData("");

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#facultySearchBtn").on("click", function (e) {
                e.preventDefault();
                getFacultyData("");
            });

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#pickDepartment").on("change", function () {
                getFacultyData("");
            });

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").on("click", "#letterFilters a", function () {
                var letter = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).text();
                getFacultyData(letter);
            });

            // On show more click
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".load-more").on("click", function () {
                showMore();
            });
        }
    }

    function showMore() {
        var showAmount = 6;
        var $facultyResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#facultyResults");

        $facultyResults.find("div.faculty-tile:hidden:lt(" + showAmount + ")").show();

        // if there are no more results, hide the load more button.
        if ($facultyResults.find("div.faculty-tile:hidden").length <= 0) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".load-more").hide();
        }
    }

    function getFacultyData(letter) {
        var department = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#pickDepartment").val();

        if (department == "All Departments") {
            department = "";
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            url: window.curry.facultyFeed,
            type: "GET",
            data: {
                Keyword: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#facultySearch").val(),
                Department: department,
                Letter: letter
            },
            success: function (response) {
                var $facultyResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#facultyResults");
                $facultyResults.html(response);

                var showAmount = 6;

                // Only show a certain amount.
                var $tiles = $facultyResults.find(".faculty-tile");

                $tiles.hide();

                $facultyResults.find("div.faculty-tile:lt(" + showAmount + ")").show();

                // Determine if the load more button should show up.
                if ($facultyResults.find("div.faculty-tile:hidden").length <= 0) {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".load-more").hide();
                } else {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".load-more").show();
                }
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    initScript();
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//dependencies


/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initScript() {

        // Filter changes
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".programs-keyword-form-control").on("keyup", function (e) {
            var keyword = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();
            if (keyword != "" && keyword.length >= 3) {
                // Passing * allows us to get results for three characters or less.
                getPredictiveProgramData(keyword, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
            } else {
                var $predictiveSearchResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#predictiveSearchProgramsPage");
                $predictiveSearchResults.html();
                $predictiveSearchResults.hide();
            }
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").on("click", "li.result-item", function () {
            // Put the value of what was clicked on into the search.
            //$(this).closest("form").find(".search-input").val($(this).html());
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest("div.row").find("#predictiveSearchProgramsPage").html();
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").on("click", function () {
            var $predictiveSearchResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#predictiveSearchProgramsPage");
            $predictiveSearchResults.html();
            $predictiveSearchResults.hide();
        });

        // Initial Load
        getProgramData();

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".programs-keyword-search-btn").on("click", function (e) {
            e.preventDefault();
            getProgramData();
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".programs-form-check-input").on("change", function () {
            getProgramData();
        });

        // On show more click
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".load-more").on("click", function () {
            showMore();
        });
    }

    function showMore() {
        var showAmount = 10;
        var $degreesAndProgramsResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#degreesAndProgramResults");

        $degreesAndProgramsResults.find("div.program-tile:hidden:lt(" + showAmount + ")").show();

        // if there are no more results, hide the load more button.
        if ($degreesAndProgramsResults.find("div.program-tile:hidden").length <= 0) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".load-more").hide();
        }
    }

    function getPredictiveProgramData(keyword) {
        var keyword = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".programs-keyword-form-control").val();

        var degreeTypes = "";

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            url: window.curry.degreesandprogramsFeed,
            type: "POST",
            data: {
                Keyword: keyword,
                DegreeTypes: degreeTypes,
                displayType: "predictive"
            },
            success: function (response) {

                var $predictiveSearchResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#predictiveSearchProgramsPage");

                if (response != "") {

                    $predictiveSearchResults.html(response);
                    $predictiveSearchResults.show();
                } else {
                    $predictiveSearchResults.hide();
                }
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    function getProgramData(predictiveKeyword) {
        var keyword = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".programs-keyword-form-control").val();

        var degreeTypes = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".programs-form-check-input:checked").map(function () {
            return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();
        }).get();

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            url: window.curry.degreesandprogramsFeed,
            type: "POST",
            data: {
                Keyword: keyword,
                DegreeTypes: degreeTypes
            },
            success: function (response) {

                var $degreesAndProgramsResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#degreesAndProgramResults");
                $degreesAndProgramsResults.html(response);

                var showAmount = 10;

                // Only show a certain amount.
                var $tiles = $degreesAndProgramsResults.find("div.program-tile");

                $tiles.hide();

                $degreesAndProgramsResults.find("div.program-tile:lt(" + showAmount + ")").show();

                // Determine if the load more button should show up.
                if ($degreesAndProgramsResults.find("div.program-tile:hidden").length <= 0) {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".load-more").hide();
                } else {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".load-more").show();
                }
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    initScript();
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//dependencies


/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initScript() {

        // Navigates user to degrees and Programs page.
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#programFinderBtn").on("click", function (e) {

            e.preventDefault();

            // Get values of filters dropdowns. 
            var interest = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#pickInterest").val();
            var subject = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#pickSubject").val();

            var params = { Interest: interest, Subject: subject };
            var href = window.curry.degreesandprogramsPage;
            href += (href.match(/\?/) ? '&' : '?') + jQuery.param(params);

            window.location.href = href + window.curry.degreesandprogramsPageTab;
        });
    }

    initScript();
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//dependencies


/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initScript() {

        // Initial Load
        getNewsData();

        // Filter changes
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("ul#newsTopics .newsTopic").on("click", function (e) {
            e.preventDefault();
            var topic = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("topic");
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#hdnTopic").val(topic);
            getNewsData();
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").on("click", 'a.pageLink', function (e) {
            e.preventDefault();
            var page = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("page");
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#hdnPage").val(page);
            // Get the height of the navigation element.
            var navigationHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#header").height();
            var callback = function () {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
                    scrollTop: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#newsResultsSection").offset().top - (navigationHeight + 50)
                });
            };

            getNewsData(callback);
        });
    }

    function getNewsData(callback) {
        var featuredPage = "";
        var hdnFeaturedPageInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#hdnFeaturedPage");
        if (hdnFeaturedPageInput.length > 0) {
            featuredPage = hdnFeaturedPageInput.val();
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            url: window.curry.newsFeed,
            type: "GET",
            data: {
                topic: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#hdnTopic").val(),
                page: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#hdnPage").val(),
                featuredPage: featuredPage
            },
            success: function (response) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#newsResults").html(response);
                if (callback) {
                    callback();
                }
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    initScript();
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//dependencies


/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initScript() {

        // Initial Load
        var $body = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body");

        populateCalendar("");
        populateEvents("");

        $body.on("click", "#calendarNext, #calendarPrevious", function () {
            var date = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("date");
            populateCalendar(date);
        });

        // Need to do this since content is dynamically generated.
        $body.on("click", ".calendarDayNumber", function () {
            var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
            var date = $this.data("date");

            var $td = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#calendarData tr td");

            // Remove active state from everything else. 
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each($td, function (key, value) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass("active");
            });

            $this.closest("td").addClass("active");
            window.curry.date = date;
            populateEvents();
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("[id^=inlineCheckbox]").on("change", function () {
            populateEvents();
        });
    }

    function populateCalendar(date) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            url: window.curry.calendarFeed,
            type: "GET",
            data: {
                Date: date
            },
            success: function (response) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#calendar").html(response);
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    function populateEvents() {
        var topics = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("[id^=inlineCheckbox]:checked").map(function () {
            return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();
        }).get();

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            type: "POST",
            url: window.curry.eventsCalendarFeed,
            data: {
                Date: window.curry.date,
                Topics: topics
            },
            success: function (response) {
                if (response !== "") {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#eventContent").html(response);
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    initScript();
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//dependencies


/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initScript() {

        // Filter changes
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".search-input").on("keyup", function (e) {
            var keyword = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();
            if (keyword != "" && keyword.length >= 3) {
                // Passing * allows us to get results for three characters or less.
                getSearchData(keyword + " *", __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
            } else {
                var $predictiveSearchResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest("div.row").find(".predictive-search-results");
                $predictiveSearchResults.html();
                $predictiveSearchResults.hide();
            }
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").on("click", "li.result-item", function () {
            // Put the value of what was clicked on into the search.
            //$(this).closest("form").find(".search-input").val($(this).html());
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest("div.row").find(".predictive-search-results").html();
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").on("click", function () {
            var $predictiveSearchResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".predictive-search-results");
            $predictiveSearchResults.html();
            $predictiveSearchResults.hide();
        });
    }

    function getSearchData(term, $searchInput) {
        if (window.curry.searchFeed.length > 0) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                url: window.curry.searchFeed,
                type: "GET",
                data: {
                    terms: term
                },
                success: function (response) {
                    var $predictiveSearchResults = $searchInput.closest("div.row").find(".predictive-search-results");

                    if (response != "") {

                        $predictiveSearchResults.html(response);
                        $predictiveSearchResults.show();
                    } else {
                        $predictiveSearchResults.hide();
                    }
                },
                error: function (xhr) {
                    //Do Something to handle error
                    alert("An error has occurred. Please contact an andministrator.");
                }
            });
        }
    }

    initScript();
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//dependencies


/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initScript() {

        // Initial Load
        getCareersData();

        // Filter changes
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#pickSubject").on("change", function () {
            getCareersData();
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#pickInterest").on("change", function () {
            getCareersData();
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".careers-form-check-input").on("change", function () {
            getCareersData();
        });

        // On show more click
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".careers-load-more").on("click", function () {
            showMore();
        });
    }

    function showMore() {
        var showAmount = 10;
        var $careerResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#careerResults");

        $careerResults.find("div.career-picker-row:hidden:lt(" + showAmount + ")").show();

        // if there are no more results, hide the load more button.
        if ($careerResults.find("div.career-picker-row:hidden").length <= 0) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".careers-load-more").hide();
        }
    }

    function getCareersData() {
        var degreeTypes = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".careers-form-check-input:checked").map(function () {
            return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();
        }).get();

        var $subject = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#pickSubject");
        var $interest = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#pickInterest");

        var subject = $subject.val();
        var interest = $interest.val();

        var subjectName = $subject.find("option:selected").text();
        var interestName = $interest.find("option:selected").text();

        if (subject == "By Subject") {
            subject = "";
        }

        if (interest == "By Interest") {
            interest = "";
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            url: window.curry.careerFeed,
            type: "POST",
            data: {
                SubjectName: subjectName,
                InterestName: interestName,
                Subject: subject,
                Interest: interest,
                DegreeTypes: degreeTypes
            },
            success: function (response) {
                var $careerResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#careerResults");
                $careerResults.html(response);

                var showAmount = 10;

                // Only show a certain amount.
                var $tiles = $careerResults.find("div.career-picker-row");

                $tiles.hide();

                $careerResults.find("div.career-picker-row:lt(" + showAmount + ")").show();

                // Determine if the load more button should show up.
                if ($careerResults.find("div.career-picker-row:hidden").length <= 0) {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".careers-load-more").hide();
                } else {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".careers-load-more").show();
                }
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    initScript();
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
//dependencies



/* harmony default export */ __webpack_exports__["a"] = (function () {

    function initScript() {
        console.log("Ini cookie alert");
        var acceptCookie = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('acceptsCookies');
        console.log(acceptCookie);
        if (acceptCookie != 'true') {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#alert').show();
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#cookie-disclaimer-close').click(function () {
            console.log("Clicked close");
            if (acceptCookie != 'true') {
                __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('acceptsCookies', 'true', { expires: 7 });
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.cookies-disclaimer').slideUp();
                return false;
            }
        });
    }
    initScript();
});

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ })
]),[25]);


// WEBPACK FOOTER //
// ui/js/app.js